module.exports = __webpack_public_path__ + "static/media/logo.a9caefc7.png";